import { useState, useEffect } from "react";
import {
  useLocation,
  useNavigate,
  useOutletContext,
  useParams,
} from "react-router-dom";
import httpService from "V2.0/services/httpService";
import { WorkflowRuns } from "./WorkflowRuns";
import { Button } from "V2.0/common/button";
import { ChevronLeftIcon } from "@heroicons/react/24/outline";
import { getPipeline } from "./service";
import { showErrorToast } from "V2.0/utils";

export function Workflow(props) {
  const { projectId, isViewOnly } = useOutletContext();
  const [workflow, setWorkflow] = useState(null);

  const location = useLocation();
  const { id } = useParams();
  const navigate = useNavigate();

  const fetchWorkflow = async () => {
    try {
      const response = await getPipeline({
        workspaceId: projectId,
        pipelineId: id,
      });
      const data = response.data;
      setWorkflow(data);
    } catch (e) {
      showErrorToast(e, "Failed to get pipeline");
    }
  };

  useEffect(() => {
    if (projectId) {
      fetchWorkflow();
    }
  }, [projectId]);

  if (workflow) {
    return (
      <div className="flex flex-col w-full h-full max-w-6xl mx-auto py-8 gap-y-8">
        <div className="flex justify-between">
          <div className="flex items-center gap-x-2">
            <Button
              onClick={() => {
                navigate({pathname: `/pipelines`, search: location.search});
              }}
              className="flex-none"
              plain
            >
              <ChevronLeftIcon className="size-4" />
            </Button>
            <p className="text-lg font-semibold ">{workflow?.name || ""}</p>
          </div>
          {!isViewOnly && (
            <Button
              onClick={() =>
                navigate({pathname: `/pipelines/${workflow._id}/edit`, search: location.search}, { state: workflow })
              }
            >
              Edit Pipeline
            </Button>
          )}
        </div>
        <div className="pl-8">
          <WorkflowRuns
            workflow={workflow}
            projectId={projectId}
          />
        </div>
      </div>
    );
  }
}
